import { RoutingFallbackTypes } from 'api/report/realTime/types'
import { CountMetricType } from 'api/report/types'
import styles from 'layouts/RealTimeDashboard/styles.module.css'
import { EMOJIS } from 'utils/chatRatingEmojis'

import { ModalType } from './components/DrilldownModal/useDrilldownConfig'

export const CSATRatingInfo = Object.freeze({
  1: { color: 'var(--color-s3-5)', emoji: EMOJIS[1] },
  2: { color: 'var(--color-s1-8)', emoji: EMOJIS[2] },
  3: { color: 'var(--color-p2-6)', emoji: EMOJIS[3] },
  4: { color: 'var(--color-p2-6)', emoji: EMOJIS[4] },
  5: { color: 'var(--color-p2-6)', emoji: EMOJIS[5] },
})

export const MissedChatInfo = Object.freeze({
  [RoutingFallbackTypes.OFFLINE]: {
    bg: 'var(--color-p3-7)',
    color: 'var(--color-p1-2)',
    label: 'No response by teammate',
    description: `The site visitor didn't receive any response at `,
  },
  [RoutingFallbackTypes.REROUTE]: {
    bg: 'var(--color-p2-6)',
    color: 'var(--color-p1-2)',
    label: 'Re-routed',
    description: `The bot re-routed to another teammate within 1 minute at `,
  },
  [RoutingFallbackTypes.TICKET]: {
    bg: 'var(--color-s4-6)',
    color: 'var(--color-p1-2)',
    label: 'Ticket created',
    description: `The bot offered to create a ticket at `,
  },
  [RoutingFallbackTypes.AWAY]: {
    bg: 'var(--color-s5-5)',
    color: 'var(--color-p1-10)',
    label: 'Away message',
    description: `The bot sent an away message at `,
  },
  [RoutingFallbackTypes.MEETING]: {
    bg: '#F4B806',
    color: 'var(--color-p1-10)',
    label: 'Meeting invite sent',
    description: `The bot sent a meeting invite at `,
  },
})

export const EMAIL_SUBJECT = 'We would like feedback from you'.replace(
  ' ',
  '%20'
)

export const RTD_SWR_CONFIG = {
  refreshInterval: window.Cypress ? 3000 : 60000,
  dedupingInterval: 2000,
  revalidateOnFocus: false,
}

export const METRIC_LABEL_MAP = Object.freeze({
  [CountMetricType.MEETING]: {
    barLabel: 'Meetings booked',
    rateNoun: 'meeting booked',
    rateNounPlural: 'meetings booked',
    verb: 'Booked',
    modalType: ModalType.NONE,
  },
  [CountMetricType.LEAD]: {
    barLabel: 'Qualified leads',
    rateNoun: 'qualified lead',
    rateNounPlural: 'qualified leads',
    verb: 'Qualified',
    modalType: ModalType.QUALIFIED_LEADS,
  },
})

export const DONUT_COLORS = Object.freeze({
  agent: 'var(--color-p3-7)',
  bot: 'var(--color-s5-5)',
  nonParticipant: 'var(--color-s1-7)',
})

const getElement = (e, wrapperClass) => {
  const xAxisLabels = document.querySelectorAll(
    `.${wrapperClass} .highcharts-axis-labels.highcharts-xaxis-labels text`
  )
  const idx = e.target.index
  return xAxisLabels[idx]
}

export const GET_CHART_HOVER_EVENTS = (wrapperClass) => ({
  mouseOver: (e: any) =>
    getElement(e, wrapperClass)?.classList.add(styles.barHoveredActive),
  mouseOut: (e: any) =>
    getElement(e, wrapperClass)?.classList.remove(styles.barHoveredActive),
})

export const RTD_MINIMIZED_PAGE_SIZE = 3
export const RTD_BAR_CHART_NUM_BARS = 5

export enum QualifiedBy {
  AGENT,
  BOT,
  NONPARTICIPANT,
}
